import { $Q } from '../utils/query-selector';

/**
 * It tries to register
 * @param {Object} email : The object with customer data to be registered
 */
export const registerAccount = (params) => {
  const {
    email,
    hashedToken,
    familyName,
    givenName,
  } = params;
  const form = $Q('#create_customer--social');

  if (!form) return;

  const submitBtn = $Q('button[type="submit"]', form);
  const firstNameInput = $Q('#RegisterForm-FirstName', form);
  const lastNameInput = $Q('#RegisterForm-LastName', form);
  const emailInput = $Q('#RegisterForm-email', form);
  const passwordInput = $Q('#RegisterForm-password', form);

  firstNameInput.value = givenName;
  lastNameInput.value = familyName;
  emailInput.value = email;
  passwordInput.value = hashedToken;

  console.log(submitBtn)

  submitBtn.click();
};

/**
  * It tries to login
  * @param {String} email : The customer email
  * @param {String} hashedToken : The token to be used as password
  */
export const loginAccount = (email, hashedToken) => {
  const form = $Q('#customer--social');

  if (!form) return;

  const submitBtn = $Q('button[type="submit"]', form);
  const emailInput = $Q('#CustomerEmail--social', form);
  const passwordInput = $Q('#CustomerPassword--social', form);

  emailInput.value = email;
  passwordInput.value = hashedToken;

  submitBtn.click();
 };
